import { useState } from "react";
import { PageHead, Reveal, Eyebrow } from "@/components/Motion";
import { Photo } from "@/components/Photo";
import { Lightbox } from "@/components/Lightbox";
import { useSite } from "@/context/SiteContext";
import { eraFor } from "@/lib/api";

export default function Story() {
  const { site } = useSite() || {};
  const items = Array.isArray(site?.timeline) ? site.timeline : [];
  const [i, setI] = useState(null);
  const lb = items.map((t) => ({ url: t.photo_url, caption: t.photo_story || `${t.year} · ${t.title}` }));
  return (
    <div data-testid="story-page">
      <PageHead eyebrow="Our Story · 1890 – 2026" title="From the first roots to today" line="From Huguenot roots and the gold fields of South Africa to Texas." />
      <section className="relative max-w-6xl mx-auto px-6 md:px-10 pb-28">
        <div className="absolute left-6 md:left-1/2 top-0 bottom-28 w-px bg-gradient-to-b from-[#C9A24B] via-[#C9A24B]/40 to-transparent" />
        <div className="flex flex-col gap-24 md:gap-32">
          {items.map((t, k) => {
            const era = eraFor(t.year).id;
            return (
              <article key={t.id} className={`relative grid gap-8 md:grid-cols-2 md:gap-16 items-center pl-8 md:pl-0`} data-testid={`timeline-entry-${t.year}`}>
                <span className="absolute left-6 md:left-1/2 top-3 -translate-x-1/2 w-3 h-3 rounded-full bg-[#C9A24B] shadow-[0_0_0_6px_rgba(201,162,75,.15)]" />
                <Reveal className={k % 2 ? "md:order-2" : ""}>
                  <Photo src={t.photo_url} era={era} onClick={() => setI(k)} ratio="16/10" alt={t.title} caption={t.photo_story || undefined} />
                </Reveal>
                <Reveal delay={0.1} className={k % 2 ? "md:order-1 md:text-right" : ""}>
                  <p className="font-display text-6xl md:text-8xl text-[#C9A24B]/90 leading-none">{t.year}</p>
                  <Eyebrow className="mt-4">{eraFor(t.year).label}</Eyebrow>
                  <h2 className="mt-3 font-display text-3xl md:text-4xl text-[#F6EFE0]">{t.title}</h2>
                  <p className="mt-4 text-base md:text-lg leading-relaxed text-[#F6EFE0]/85">{t.story}</p>
                  {t.background && !t.sample && <span className="badge-sample mt-5 mr-2" data-testid={`timeline-background-${t.year}`}>Historical background</span>}
                </Reveal>
              </article>
            );
          })}
        </div>
      </section>
      <Lightbox items={lb} index={i} onClose={() => setI(null)} onIndex={setI} />
    </div>
  );
}
